import React from 'react';
import PillarColumn from './PillarColumn';

const PILLAR_ORDER = ['IDENTITY', 'DEVICE', 'NETWORK', 'APPLICATION', 'DATA', 'VISIBILITY'];

const PillarGrid = ({
  pillars = [],
  assessments = [],
  vendorOverlay,
  assessmentMode = false,
  onUpdateAssessment
}) => {
  // Sort pillars by the defined order
  const sortedPillars = [...pillars].sort((a, b) => {
    const ai = PILLAR_ORDER.indexOf(a.pillar_code);
    const bi = PILLAR_ORDER.indexOf(b.pillar_code);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });

  return (
    <div className={`pillar-grid ${vendorOverlay ? 'pillar-grid--vendor-mode' : ''}`}>
      {sortedPillars.map(pillar => (
        <PillarColumn
          key={pillar.pillar_id || pillar.pillar_code}
          pillar={pillar}
          assessments={assessments}
          vendorOverlay={vendorOverlay}
          assessmentMode={assessmentMode}
          onUpdateAssessment={onUpdateAssessment}
        />
      ))}
    </div>
  );
};

export default PillarGrid;
